

































import { Component, Emit, Vue, Prop } from 'vue-property-decorator';
import moment from 'moment';

import ButtonPanel from '@/components/menu/panel/ButtonPanel.vue';
import IconButton from '@/components/atom/button/IconButton.vue';
import NormalButton from '@/components/atom/button/NormalButton.vue';
import AmountField from '@/components/atom/input/AmountField.vue';
import ConfirmDialog from '@/components/atom/dialog/ConfirmDialog.vue';
import AlertDialog from '@/components/atom/dialog/AlertDialog.vue';
import SenderSelector from '@/components/user/SenderSelector.vue';
import ToggleButtonField from '@/components/atom/input/ToggleButtonField.vue';
import {在庫調整型} from '@/type/adjustment/records/register/在庫調整登録';

@Component({
  components: {
    ToggleButtonField,
    ButtonPanel,
    IconButton,
    NormalButton,
    AmountField,
    ConfirmDialog,
    AlertDialog,
    SenderSelector,
  },
  filters: {
    日付フォーマット(date: Date): string | null {
      if (date === null) {
        return '';
      }
      return moment(date).format('YYYY/MM/DD');
    },
    数値フォーマット(value: number): string {
      if (value === null) {
        return '';
      }
      return value.toFixed(3);
    },
  },
})
export default class RegisterMovement extends Vue {
  // data
  @Prop()
  value!: 在庫調整型;
  @Prop()
  rowIndex!: number;

  @Emit()
  clickRowSelect(): object {
    return {value: this.value};
  }

  調整後管理外トグルボタンが無効である(value: 在庫調整型): boolean {
    return value.採用品管理対象外フラグ === '対象外';
  }
}
